<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="retrieval texture-bg-css">
    <div class="retrieval-box">
      <Card :bordered="false">
        <p slot="title">高级检索</p>

        <Row class="border-bottom">
          <Col
            span="4"
            v-for="item in select"
            :key="item.id"
            class="retrieval-search"
          >
            <div v-if="item.type == 'select'">
              <Select
                v-model="form[item.id]"
                placeholder=""
                @on-change="conditionChanged(item)"
              >
                <span slot="prefix">{{ item.name }}</span>
                <Option
                  v-for="option in chartData[item.option] || options.yesorno"
                  :value="option.id"
                  :key="`${item.option}_${option.id}`"
                  >{{ option.name }}</Option
                >
              </Select>
            </div>

            <div
              v-else-if="item.type == 'range'"
              class="range-box overflow-hidden"
            >
              <Input v-model="form.age" placeholder="年龄" class="range-input">
                <span slot="append">至</span>
              </Input>
              <Input v-model="form.age" placeholder="年龄" class="range-input">
                <span slot="append">岁</span>
              </Input>
            </div>
          </Col>
          <Col span="4">
            <Button type="primary" class="submit" @click="init"
              >开始查询</Button
            >
          </Col>
        </Row>
        <div
          v-if="selectedId && selectedChart && selectedChart == 'bar'"
          class="bar-chart"
        >
          <div class="chart-title relative">{{ selectedName }}情况柱状图</div>
          <div class="chart-box" id="barChart"></div>
        </div>
        <div
          v-if="selectedId && selectedChart && selectedChart == 'pie'"
          class="pie-chart"
        >
          <div class="chart-title relative">{{ selectedName }}情况饼图</div>
          <div class="chart-box" id="pieChart"></div>
        </div>
        <div v-if="!selectedId" class="text-center h-64 mt-12">暂无数据</div>
      </Card>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import retrieval from '@/views/mixins/retrieval.js'
export default {
  name: 'retrieval',
  components: {},
  mixins: [retrieval],
  data() {
    return {
      form: { sex: null },
      selectedId: null,
      selectedName: null,
      selectedChart: null,
      barChart: null,
      pieChart: null,
      select: [
        {
          id: 'sex',
          name: '性别',
          type: 'select',
          option: 'sex',
          chart: 'pie'
        },
        { id: 'age', name: '年龄', type: 'select', option: 'age' },
        // { id: 'age', name: '年龄', type: 'range', option: null },
        {
          id: 'nation',
          name: '民族',
          type: 'select',
          option: 'nation',
          chart: 'pie'
        },
        {
          id: 'nativePlace',
          name: '籍贯',
          type: 'select',
          option: 'nativePlace'
        },
        {
          id: 'studyType',
          name: '研究类型',
          type: 'select',
          option: 'studyType',
          chart: 'pie'
        },
        {
          id: 'sampleType',
          name: '样本类型',
          type: 'select',
          option: 'sampleType'
        },

        { id: 'health', name: '健康状况', type: 'select', option: 'health' },
        {
          id: 'system',
          name: '样本涉及的系统',
          type: 'select',
          option: 'system'
        },

        {
          id: 'condition',
          name: '保存条件',
          type: 'select',
          option: 'condition'
        },
        {
          id: 'principle',
          name: '共存原则',
          type: 'select',
          option: 'principle'
        },
        {
          id: 'share',
          name: '共享内容',
          type: 'select',
          option: 'share',
          chart: 'pie'
        }
      ],
      options: {
        yesorno: [
          // { id: '0', name: '否' },
          { id: '1', name: '是' }
        ]
        // sex: [
        //   { id: '0', name: '男' },
        //   { id: '1', name: '女' },
        //   { id: '2', name: '未知' }
        // ]
      },
      barChartOption: {
        color: ['#46BFB8'],
        grid: {
          left: 0,
          right: 26,
          bottom: 80,
          top: 35,
          containLabel: true
        },
        tooltip: {
          show: true,
          trigger: 'item',
          position: 'left'
          // formatter: params => {
          //   const { name, value } = params
          //   return `
          //    <div style="line-height: 1.8;">${name}</div>
          //   <div style="position: relative;line-height: 1.8;vertical-align: bottom;">${value}${this.unit}</div>
          //   `
          // },
          // extraCssText:
          //   'box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);padding: 8px;width: 140px;border: 0 none;'
        },
        // dataZoom: [
        //   {
        //     start: 0,
        //     end: 100,
        //     height: 15
        //   }
        // ],
        xAxis: {
          type: 'category',
          axisTick: {
            show: false //显示刻度线
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#646A77', //更改坐标轴文字颜色
              fontSize: 12 //更改坐标轴文字大小
            }
          },
          axisLine: {
            lineStyle: {
              color: '#F3F4F5',
              width: 1
            }
          },
          data: [
            '唾液及口腔细胞',
            '尿液',
            '血液',
            '关节腔液',
            '指甲及头发',
            '脑脊'
          ]
        },
        yAxis: {
          type: 'value',
          // min: 1,
          // logBase: 10,
          axisLine: {
            show: true, //y轴线
            lineStyle: {
              color: '#F3F4F5'
            }
          },
          axisTick: {
            show: false //显示刻度线
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#646A77', //更改坐标轴文字颜色
              fontSize: 14 //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#F3F4F5'
            }
          }
        },
        series: [
          {
            data: [4000, 4000, 7400, 6433, 4000, 4000],
            barWidth: 28,
            type: 'bar',
            barMinHeight: 5,
            label: {
              show: true,
              position: 'top',
              color: 'inherit'
            }
          }
        ]
      },
      pieChartOption: {
        title: {
          // 主标题样式
          textStyle: {
            color: '#646A77',
            fontSize: 18,
            lineHeight: 25
          },
          itemGap: 0,
          text: '总数',
          subtext: 0,
          // 副标题样式
          subtextStyle: {
            color: '#111A2E',
            fontSize: 30,
            lineHeight: 42
          },
          left: 'center',
          top: '40%'
        },
        grid: {
          left: 0,
          right: 26,
          bottom: 105,
          top: 35
        },
        legend: {
          top: 'middle',
          right: '5%',
          orient: 'vertical',
          itemWidth: 25,
          borderRadius: 2
        },
        color: [
          '#46BFB8',
          '#3FD5EA',
          '#436DFF',
          '#C889FF',
          '#633DEA',
          '#FF5F70',
          '#E34141',
          '#FFB404',
          '#FFAC92'
        ],
        series: {
          name: '',
          type: 'pie',
          radius: ['45%', '60%'],
          center: ['50%', '48%'],
          label: {
            color: '#303849',
            fontSize: '14'
          },
          labelLine: {
            lineStyle: { color: '#E2E3E5' }
          },
          emphasis: {
            label: {
              formatter: '{b}: {c}'
            }
          },
          data: []
        }
      }
    }
  },
  beforeDestroy() {
    if (window.onresize) {
      window.onresize = null
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.selectedId) {
        if (this.selectedChart == 'bar') {
          this.barChartInit()
        }
        if (this.selectedChart == 'pie') {
          this.pieChartInit()
        }
      }
    },
    dispose() {
      if (this.selectedId) {
        if (document.getElementById('barChart'))
          echarts.init(document.getElementById('barChart')).dispose()
        if (document.getElementById('pieChart'))
          echarts.init(document.getElementById('pieChart')).dispose()
      }
    },
    conditionChanged(item) {
      let id = item.id
      let name = item.name
      let chart = item.chart

      let value = this.form[id]
      if (value || value == 0) {
        this.dispose()
        this.selectedId = id
        this.selectedName = name
        this.selectedChart = chart ? chart : 'bar'
        Object.keys(this.form).map(v => {
          if (v !== id) this.form[v] = null
          return v
        })
        this.$nextTick(() => {
          this.init()
        })
      }
    },
    barChartInit() {
      var barChart = echarts.init(document.getElementById('barChart'))
      this.barChart = barChart
      this.barChartOption.xAxis.data = this.chartData[this.selectedId].map(
        v => v.name
      )
      this.barChartOption.series[0].data = this.chartData[this.selectedId].map(
        v => v.value
      )
      barChart.setOption(this.barChartOption)
      window.onresize = () => {
        this.barChart.resize()
      }
    },
    pieChartInit() {
      var pieChart = echarts.init(document.getElementById('pieChart'))
      this.pieChart = pieChart
      this.pieChartOption.series.data = this.chartData[this.selectedId]
      this.pieChartOption.title.subtext = this.chartData[
        this.selectedId
      ].reduce((acc, cur) => {
        acc += Number(cur.value)
        return acc
      }, 0)
      pieChart.setOption(this.pieChartOption)
      window.onresize = () => {
        this.pieChart.resize()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';

.ivu-card {
  border-radius: 0;
  box-shadow: 0 0 20px rgba(109, 109, 109, 0.25);
}
/deep/ .ivu-card-head {
  height: 2.5vw; //48px;
  background-color: #f3f4f5;
  color: $c-black;
  border: 0 none;
  font-size: 0.83vw; //16px;
}
/deep/ .ivu-card-body {
  padding: 1.41vw 0 4px 0; //27px 0 4px 0;
  > div {
    padding: 0 1.35vw 0 2.29vw; // 0 26px 0 44px;
  }
}
/deep/ .ivu-select-selection {
  border: 1px solid #e2e3e5;
  border-radius: 4px;
  height: 1.98vw; //1.98vw;//38px;
  line-height: 1.875vw; //36px;
  font-size: 0.73vw; //14px;
  color: #111a2e;
  > div {
    line-height: 1.875vw;
  }
}
/deep/ .ivu-input {
  border: 0 none;
  height: 1.875vw;
  line-height: 1.875vw;
  font-size: 0.73vw; //14px;
  color: #111a2e;
}
/deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
/deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  font-size: 0.73vw; //14px;
}
/deep/ .ivu-icon-ios-arrow-down:before {
  content: '▾';
  color: #b9bcc1;
}
/deep/ .ivu-select-prefix {
  padding-left: 0.68vw; //13px;
}

.retrieval {
  border-top: 1px solid #f0f1f2;
}
.retrieval-box {
  width: 71.15vw; //1366px;
  margin: 0 auto;
  padding: 1.67vw 0 2.92vw 0; //32px 0 56px 0;
}
.retrieval-search {
  padding-right: 0.83vw; //16px;
  padding-bottom: 0.83vw; //16px;
}
.range-box {
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #e2e3e5;
}
.range-input {
  float: left;
  width: 50%;
  /deep/ .ivu-input-group-append {
    border: 0 none;
    background-color: $c-white;
  }
}
.submit {
  border: 0 none;
  // max-width: 134px;
  background: #46bfb8;
  border-radius: 6px;
  height: 1.98vw; //38px;
  line-height: 1.98vw; //38px;
  padding: 0 2.03vw; //0 39px;
  font-size: 0.73vw; //14px;
  &:hover {
    box-shadow: 0 0 10px rgba(109, 109, 109, 0.25);
  }
}
.border-bottom {
  border-bottom: 1px solid #f0f1f2;
}
.chart-title {
  padding: 1.67vw 0 0 0.52vw; //32px 0 0 10px;
  font-size: 0.9375vw; //18px;
  line-height: 1;
  color: #111a2e;
  &:before {
    content: '';
    display: inline-block;
    width: 3px;
    height: 0.99vw; //19px;
    background-color: #46bfb8;
    position: absolute;
    top: 1.67vw; //32px;
    left: 0;
  }
}
.chart-box {
  height: 24.79vw; //476px; //364px;
}
.pie-chart {
  .chart-box {
    height: 22.76vw; //437px;
  }
}
</style>
